
const requiredMsg = 'This field is required'

const positiveIntegerMsg = 'The quantity must be a postive integer'

const integerMsg = 'The quantity must be an integer'

export { requiredMsg, positiveIntegerMsg, integerMsg }

